import React from "react";

import { useTheme } from "../../../context/theme";
import { Box } from "../../layout";
import { Text } from "../../typography";
import { directionToStylesMap } from "./consts";
import { Direction, DividerEmphasis } from "./types";

type Props = {
  direction?: Direction;
  emphasis?: DividerEmphasis;
  includeOr?: boolean;
};

export default function Divider({
  direction = "horizontal",
  emphasis = "xLow",
  includeOr = false
}: Props) {
  const theme = useTheme();

  const color =
    emphasis === "xLow"
      ? theme["neutral-xLow-content"]
      : theme["neutral-low-content"];

  const { width, height } = directionToStylesMap[direction];

  return (
    <Box
      width={width}
      height={height}
      display="flex"
      flexDirection={direction === "horizontal" ? "row" : "column"}
      alignItems="center"
    >
      <Box width={width} height={height} backgroundColor={color} />
      {includeOr && (
        <Box padding="large">
          <Text size="small" emphasis="medium">
            OR
          </Text>
        </Box>
      )}
      <Box width={width} height={height} backgroundColor={color} />
    </Box>
  );
}
